/**
 * Detects if the current browser is Safari or a Safari-based browser
 * This is necessary for Apple Pay support detection as Apple Pay only works in Safari
 *
 * @returns {boolean} True if running in Safari on iOS/iPadOS or macOS, false otherwise
 */
export const isSafari = (): boolean => {
  if (typeof window === 'undefined') return false;

  const ua = window.navigator.userAgent;

  // Check for iOS devices (iPhone, iPad, iPod)
  const iOS = /iPad|iPhone|iPod/.test(ua);
  const webkit = /WebKit/.test(ua);

  // iOS Safari: Has WebKit but not Chrome, Firefox, or Opera iOS versions
  const iOSSafari = iOS && webkit && !/CriOS|FxiOS|OPiOS|mercury/.test(ua);

  // Check for macOS
  const macOS = /Macintosh/.test(ua);

  // macOS Safari: Has WebKit but not Chrome, Chromium, or Edge
  // Note: Safari on macOS contains both 'Safari' and 'Version' in UA
  const macOSSafari = macOS && webkit && !/Chrome|Chromium|Edg/.test(ua);

  return iOSSafari || macOSSafari;
};